import React, { useState } from 'react';
import { cameraApi } from '../../services/api';
import toast from 'react-hot-toast';
import './PTZControl.css';
interface Props { cameraId: number; }
export default function PTZControl({ cameraId }: Props) {
  const [pos, setPos] = useState({ h: 90, v: 90 });
  const [loading, setLoading] = useState(false);
  const move = async (dir: string) => {
    if (loading) return; setLoading(true);
    try { const { data } = await cameraApi.ptzMove(cameraId, dir); setPos(data.pos); }
    catch { toast.error('PTZ xəta'); } finally { setLoading(false); }
  };
  return (
    <div className="ptz-wrap">
      <div className="ptz-label">PTZ İDARƏ</div>
      <div className="ptz-grid">
        <div/><button className="ptz-btn" onClick={() => move('up')} disabled={loading}>▲</button><div/>
        <button className="ptz-btn" onClick={() => move('left')} disabled={loading}>◀</button>
        <button className="ptz-btn center" onClick={() => move('center')} disabled={loading}>⊙</button>
        <button className="ptz-btn" onClick={() => move('right')} disabled={loading}>▶</button>
        <div/><button className="ptz-btn" onClick={() => move('down')} disabled={loading}>▼</button><div/>
      </div>
      <div className="ptz-pos">H: {pos.h}°&nbsp;&nbsp;V: {pos.v}°</div>
    </div>
  );
}
